export default __webpack_public_path__ + "static/media/Sorting_04.a3250ea9.png";